import { useMemo } from "react";

import { EventStatsDatum, mapEventToStats } from "./shared";

const useEventStats = (events: InfoEvent[]): EventStatsDatum[] =>
  useMemo(() => events.map(mapEventToStats), [events]);

export default useEventStats;
